import React from 'react';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';

// Inspired by the former Facebook spinners.
const useStyles = makeStyles((theme) => ({
    container:{
        position:'fixed',
        top:'50%',
        left:'50%',
        transform:'translate(-50%,-50%)'
    },
    root: {
        color: '#1a90ff',
        animationDuration: '750ms',
    },
    circle: {
        strokeLinecap: 'round',
    },
}));
export default function Loader(props:any) {
    const classes = useStyles();
    const { show } = props;
    return (
        <Box className={classes.container}>
            <CircularProgress
                variant="indeterminate"
                className={classes.root}
                classes={{
                    circle: classes.circle,
                }}
                size={40}
                thickness={4}
            />
        </Box>
    )
}